import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import LeftArray from "assets/images/prev-btn.png";
import RightArray from "assets/images/next-btn.png";
import { history } from "redux/store/store";
import {
  GetCategories,
  GetProductsByCategory,
  ProductsList,
} from "service/apis/products.apis";
import { Tabs, Tab } from "react-bootstrap";

import nextArrow from "../../../assets/svg/rightArrow.svg";
import prevArrow from "../../../assets/svg/leftArrow.svg";

import { formatCurrency } from "../../../utils/Currency";
import Currency from "component/Currency/page";

const CollectionTabs = () => {
  const [loading, setLoading] = useState(false);
  const [tabData, setTabData] = useState([]);

  const [trending, setTrending] = useState([]);
  const [bestSelling, setBestSelling] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  let payloadOfTrending, payloadOfBestSellers, payloadOfNewArrivals;

  //dev collection ids
  payloadOfTrending = {
    categoryId: "gid://shopify/Collection/280293441583",
    sortKey: "BEST_SELLING",
    reverse: false,
  };
  payloadOfBestSellers = {
    categoryId: "gid://shopify/Collection/280293441583",
    sortKey: "MANUAL",
    reverse: false,
  };
  payloadOfNewArrivals = {
    categoryId: "gid://shopify/Collection/291836198959",
    sortKey: "MANUAL",
    reverse: false,
  };

  //prod collection ids
  // payloadOfTrending = {
  //   categoryId: "gid://shopify/Collection/293456412838",
  //   sortKey: "BEST_SELLING",
  //   reverse: false,
  // };
  // payloadOfBestSellers = {
  //   categoryId: "gid://shopify/Collection/293457363110",
  //   sortKey: "MANUAL",
  //   reverse: false,
  // };
  // payloadOfNewArrivals = {
  //   categoryId: "gid://shopify/Collection/293457395878",
  //   sortKey: "MANUAL",
  //   reverse: false,
  // };

  const category = async () => {
    setLoading(true);
    try {
      let response = await GetCategories();

      setTabData(response);
      setLoading(false);

      let products1 = await GetProductsByCategory(payloadOfTrending);
      let products2 = await GetProductsByCategory(payloadOfBestSellers);
      let products3 = await GetProductsByCategory(payloadOfNewArrivals);

      setTrending(products1);
      setBestSelling(products2);
      setNewArrivals(products3);

      // console.log(products3, "products3");
    } catch (err) {}
  };

  // new arrivals
  const swiperOptions2 = {
    initialSlide: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: "row",
      },
      400: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: "row",
      },
      600: {
        slidesPerView: 2,
      },
      750: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  };
  // best seller
  const swiperOptions1 = {
    initialSlide: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: "row",
      },
      400: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: "row",
      },
      600: {
        slidesPerView: 2,
      },
      750: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  };

  //what's trending
  const swiperOptions = {
    initialSlide: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      320: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: "row",
      },
      400: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: "row",
      },
      600: {
        slidesPerView: 2,
      },
      750: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  };

  useEffect(() => {
    category();
  }, [bestSelling]);

  return (
    <>
      <section>
        <h4 className="text-center py-3 main--title">Shop by Products</h4>
      </section>

      <section id="multipleTabs" className="">
        <Tabs
          defaultActiveKey="Best Sellers"
          id="uncontrolled-tab-example2"
          className="collectionTabs"
        >
          <Tab eventKey="Best Sellers" title="Best Sellers">
            <div className="categorySwiper homeSwipers">
              {/* <div>
                <div id='catPrev1' className='catePrevBtn d-md-none d-block'>
                  <img alt='' src={LeftArray} className='' />
                  Prev
                </div>
              </div> */}

              <Swiper
                {...swiperOptions1}
                spaceBetween={18}
                slidesPerView={3}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
              >
                {bestSelling.map((item, i) => {
                  const price = Number(
                    item.node?.priceRange?.minVariantPrice?.amount
                  );

                  if (price === 0) {
                    return null; // Skip rendering this product
                  }

                  return (
                    <SwiperSlide key={i}>
                      <a
                        onClick={() =>
                          history.push(`/product/${item.node.handle}`)
                        }
                        className="product--a"
                      >
                        <div className="product--container">
                          <div className="">
                            {item.node.id ===
                            "gid://shopify/Product/7713922973862" ? (
                              <span className="badge new-badge">New</span>
                            ) : (
                              <></>
                            )}
                            {item.node.images?.nodes.map((image, index) => {
                              return (
                                <img
                                  className={`img-fluid heree img${index}`}
                                  src={image.url}
                                  key={index}
                                  alt=""
                                />
                              );
                            })}
                            <span className="price">
                              <Currency />
                              {formatCurrency(price)}
                            </span>
                          </div>
                        </div>
                        <h1 className="product-title">{item.node.title}</h1>
                      </a>
                    </SwiperSlide>
                  );
                })}

                <div className="swiper-button-next">
                  <img src={nextArrow} alt="Arrow Right" />
                </div>
                <div className="swiper-button-prev">
                  <img src={prevArrow} alt="Arrow Left" />
                </div>
              </Swiper>
            </div>
          </Tab>
        </Tabs>
      </section>

      <section id="multipleTabs" className="">
        <Tabs
          defaultActiveKey="New Arrivals"
          id="uncontrolled-tab-example2"
          className="collectionTabs"
        >
          <Tab eventKey="New Arrivals" title="New Arrivals">
            <div className="categorySwiper homeSwipers">
              <Swiper {...swiperOptions2} spaceBetween={18} slidesPerView={3}>
                {newArrivals?.map((item, i) => {
                  const price = Number(
                    item.node?.priceRange?.minVariantPrice?.amount
                  );

                  if (price === 0) {
                    return null; // Skip rendering this product
                  }

                  return (
                    <SwiperSlide key={i}>
                      <a
                        onClick={() =>
                          history.push(`/product/${item.node.handle}`)
                        }
                        className="product--a"
                      >
                        <div className="product--container">
                          <div className="">
                            {item?.node?.tags?.find((tag) => tag === "New") ? (
                              <span className="badge new-badge">New</span>
                            ) : (
                              <></>
                            )}

                            {item.node.images?.nodes.map((image, index) => {
                              return (
                                <img
                                  className={`img-fluid heree img${index}`}
                                  src={image.url}
                                  key={index}
                                  alt=""
                                />
                              );
                            })}
                            <span className="price">
                              <Currency />
                              {formatCurrency(price)}
                            </span>
                          </div>
                        </div>
                        <h1 className="product-title">{item.node.title}</h1>
                      </a>
                    </SwiperSlide>
                  );
                })}

                <div className="swiper-button-next">
                  <img src={nextArrow} alt="Arrow Right" />
                </div>
                <div className="swiper-button-prev">
                  <img src={prevArrow} alt="Arrow Left" />
                </div>
              </Swiper>
            </div>
          </Tab>
        </Tabs>
      </section>

      <section id="multipleTabs" className="">
        <Tabs
          defaultActiveKey="What's Trending"
          id="uncontrolled-tab-example"
          className="collectionTabs"
        >
          <Tab eventKey="What's Trending" title="What's Trending">
            <div className="categorySwiper homeSwipers">
              {/* <div>
                <div id='catPrev' className='catePrevBtn d-md-none d-block'>
                  <img alt='' src={LeftArray} className='' />
                  Prev
                </div>
              </div> */}
              <Swiper
                {...swiperOptions}
                spaceBetween={18}
                slidesPerView={3}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
              >
                {trending.map((item, i) => {
                  const price = Number(
                    item.node?.priceRange?.minVariantPrice?.amount
                  );

                  if (price === 0) {
                    return null; // Skip rendering this product
                  }

                  return (
                    <SwiperSlide key={i}>
                      <a
                        className="product--a"
                        onClick={() =>
                          history.push(`/product/${item.node.handle}`)
                        }
                      >
                        <div className="product--container">
                          <div className="">
                            {item.node.id ===
                            "gid://shopify/Product/7713922973862" ? (
                              <span className="badge new-badge">New</span>
                            ) : (
                              <></>
                            )}
                            {item.node.images?.nodes.map((image, index) => {
                              return (
                                <img
                                  alt={item.node.title}
                                  className={`img-fluid heree img${index}`}
                                  src={image.url}
                                  key={index}
                                />
                              );
                            })}
                            <span className="price">
                              <Currency />
                              {formatCurrency(price)}
                            </span>
                          </div>
                        </div>
                        <h1 className="product-title">{item.node.title}</h1>
                      </a>
                    </SwiperSlide>
                  );
                })}

                <div className="swiper-button-next">
                  <img src={nextArrow} alt="Arrow Right" />
                </div>
                <div className="swiper-button-prev">
                  <img src={prevArrow} alt="Arrow Left" />
                </div>
              </Swiper>
              {/* <div>
                <div id='catNext' className='cateNextBtn d-md-none d-block'>
                  <span>Next </span>
                  <img alt='' src={RightArray} className=' ' />
                </div>
              </div> */}
            </div>
          </Tab>
        </Tabs>
      </section>
    </>
  );
};

export default CollectionTabs;
